<template>
  <div class="sz-footer-background print-break-avoid">
    <v-container>
      <v-row
        no-gutters
        justify="space-between"
        class="pt-0 pt-sm-3 pt-md-5"
      >
        <v-col
          cols="12"
          sm="6"
          md="1"
          class="d-none d-sm-block ml-8 ml-sm-0 pl-lg-8 hidden-print-only"
        >
          <LogoComponent
            :width="80"
            :height="80"
          />
        </v-col>
        <v-col
          v-if="isBetween"
          cols="12"
          sm="6"
          md="4"
          class="sz-white--text pl-0 mt-3 mt-sm-0 pr-0 pr-sm-1 px-lg-8"
        >
          <p class="f-16 font-weight-medium mb-3">
            {{ $t('footer.gotQuestions') }}
          </p>
          <v-row
            no-gutters
            class="flex-nowrap"
          >
            <v-col
              cols="1"
              sm="auto"
            >
              <v-icon
                :size="16"
                color="szLightGrey"
                class="mt-1"
              >
                $phone
              </v-icon>
            </v-col>
            <v-col
              cols="11"
              sm="auto"
              class="sz-white--text font-weight-regular pl-3"
            >
              <p class="f-18 mb-0">
                <BasePhone :phone="$t('general.helpdeskNumber')" />
              </p>
            </v-col>
          </v-row>
          <v-row
            no-gutters
            class="flex-nowrap"
          >
            <v-col
              cols="1"
              sm="auto"
            >
              <v-icon
                :size="16"
                color="szLightGrey"
                class="mt-1"
              >
                $email
              </v-icon>
            </v-col>
            <v-col
              cols="11"
              sm="auto"
              class="sz-white--text font-weight-regular pl-3"
            >
              <p class="f-18 mb-0">
                biuro@wiosna.org.pl
              </p>
            </v-col>
          </v-row>
          <p class="f-16 font-weight-medium mb-3 mt-5">
            {{ $t('footer.company_contact') }}
          </p>
          <v-row
            no-gutters
            class="flex-nowrap"
          >
            <v-col
              cols="1"
              sm="auto"
            >
              <v-icon
                :size="16"
                color="szLightGrey"
                class="mt-1"
              >
                $email
              </v-icon>
            </v-col>
            <v-col
              cols="11"
              sm="auto"
              class="sz-white--text font-weight-regular pl-3"
            >
              <p class="f-18 mb-0">
                firma@wiosna.org.pl
              </p>
            </v-col>
          </v-row>
        </v-col>
        <v-col
          v-else
          cols="12"
          sm="6"
          md="4"
          class="sz-white--text pl-0 mt-3 mt-sm-0 pr-0 pr-sm-1 px-lg-8"
        >
          <p class="f-16 font-weight-medium mb-3">
            {{ $t('footer.gotQuestions') }}
          </p>
          <p class="f-14">
            {{ callCenter.title }}
          </p>
          <v-row
            no-gutters
            class="flex-nowrap"
          >
            <v-col
              cols="1"
              sm="auto"
            >
              <v-icon
                :size="16"
                color="szLightGrey"
                class="mt-1"
              >
                $phone
              </v-icon>
            </v-col>
            <v-col
              cols="11"
              sm="auto"
              class="sz-white--text font-weight-regular pl-3"
            >
              <p class="f-18 mb-0">
                <BasePhone :phone="callCenter.phone" />
              </p>
              <p
                v-if="callCenter.text"
                class="f-14 mb-3"
              >
                {{ callCenter.text }}
              </p>
            </v-col>
          </v-row>
          <v-row
            no-gutters
            class="flex-nowrap"
          >
            <v-col
              cols="1"
              sm="auto"
            >
              <v-icon
                :size="16"
                color="szLightGrey"
                class="mt-1"
              >
                $email
              </v-icon>
            </v-col>
            <v-col
              cols="11"
              sm="auto"
              class="sz-white--text font-weight-regular pl-3"
            >
              <p class="f-18 mb-0">
                <BaseEmail :email="$t('footer.donorEmail')" />
              </p>
            </v-col>
          </v-row>
          <v-row
            v-if="isTidioChatEnabledBasedOnEditionStage"
            no-gutters
            class="flex-nowrap"
          >
            <v-col
              cols="1"
              sm="auto"
            >
              <v-icon
                color="szLightGrey"
                :size="16"
              >
                $onlineChat
              </v-icon>
            </v-col>
            <v-col
              cols="11"
              sm="auto"
              class="sz-white--text font-weight-regular pl-3"
            >
              <p class="f-18 mb-0">
                <button @click="openChat">
                  {{ $t('footer.onlineChat') }}
                </button>
              </p>
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          md="4"
          class="sz-white--text mt-3 mt-sm-5 mt-md-0 pr-0 px-lg-8 hidden-print-only"
        >
          <p class="f-16 font-weight-medium mb-3">
            {{ $t('label.usefulLinks') }}
          </p>
          <ul class="f-14 pa-0 footer-link-list">
            <li>
              <RouterLink :to="{name: ROUTE_NAMES.HOME, query: $route.query }">
                {{ goToHomeLabel }}
              </RouterLink>
            </li>
            <li
              v-for="(link, index) in footerLinks"
              :key="index"
            >
              <a
                :href="link?.href"
                target="_blank"
              >{{ link?.text }}</a>
            </li>
          </ul>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          md="3"
          class="sz-white--text my-3 mt-sm-5 mt-md-0 mb-sm-0 px-lg-8 hidden-print-only"
        >
          <p class="f-16 font-weight-medium mb-0 d-none d-sm-inline-block">
            {{ $t('footer.stayUpdated') }}
          </p>
          <p class="d-none d-sm-block my-4">
            <a
              v-for="(icon, index) in FOOTER_ICONS"
              :key="index"
              :href="icon.href"
              target="_blank"
            >
              <v-icon
                class="mr-4"
                :size="iconSize"
                :color="iconColor"
                :icon="icon.name"
              />
            </a>
          </p>
          <p class="f-12 mb-0 sz-footer-grey-light--text">
            {{ $t('footer.copy', { currentYear }) }}
          </p>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import LogoComponent from '@/components/widgets/LogoComponent';
import { FOOTER_ICONS, LINKS } from '@/constants/externalLinks';
import getLangsVariable from '@/utils/getLangsVariable';
import { useGoTo } from 'vuetify';
import { useTidio } from '@/stores/Tidio';
import BaseEmail from '@/components/widgets/BaseEmail.vue';
import BasePhone from '@/components/widgets/BasePhone.vue';
import useEditionStageStore from '@/stores/EditionStage';
import { storeToRefs } from 'pinia';
import ROUTE_NAMES from '@/constants/routeNames';

export default {
    name: 'FooterComponent',
    components: { LogoComponent, BaseEmail, BasePhone },
    props: {
        iconSize: {
            type: Number,
            default: 25
        },
        iconColor: {
            type: String,
            default: 'szViolet'
        }
    },
    setup () {
        const goTo = useGoTo();

        const tidio = useTidio();
        const { isTidioChatEnabledBasedOnEditionStage } = storeToRefs(tidio);
        const openChat = () => {
            tidio.openChat();
        };
        return { goTo, openChat, isTidioChatEnabledBasedOnEditionStage };
    },
    data () {
        return {
            FOOTER_ICONS,
            LINKS,
            currentYear: new Date().getFullYear(),
            ROUTE_NAMES
        };
    },
    computed: {
        callCenter () {
            return {
                title: getLangsVariable(['OTHER', 'callCenter', 'title']) || this.$t('footer.callCenter.title'),
                phone: getLangsVariable(['OTHER', 'callCenter', 'phone']) || this.$t('footer.callCenter.phone'),
                text: getLangsVariable(['OTHER', 'callCenter', 'text']) || this.$t('footer.callCenter.text')
            };
        },
        isBetween () {
            const editionStageStore = useEditionStageStore();
            const { isBetweenCampaign } = storeToRefs(editionStageStore);
            return isBetweenCampaign.value;
        },
        isHomePage () {
            return this.$route.name === ROUTE_NAMES.HOME;
        },
        goToHomeLabel () {
            return this.isHomePage ? this.$t('footer.scrollTop') : this.$t('footer.goToLocation');
        },
        footerLinks () {
            return this.$tm('footer.links');
        }
    }
};
</script>
